import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

/** The uploaded PDF's pages (server: page_view.pages). */
export interface ManuscriptPages {
  count: number;
  sizes: [number, number][];   // width, height in points, in page order
  fp: string;                  // the PDF's fingerprint, for the pictures' URLs
}

export function useManuscriptPages(projectId: string | undefined) {
  return useQuery({
    queryKey: ["manuscript-pages", projectId],
    queryFn: () => api<ManuscriptPages>(`/api/modules/proofing/projects/${projectId}/manuscript-pages`),
    staleTime: 10 * 60_000,
    retry: false,
    enabled: !!projectId,
  });
}

/** Where each of a chapter's words sits on its PDF page, as fractions of the
 *  page: token index -> [pdf page, x0, y0, x1, y1]. */
export function usePageWords(projectId: string | undefined, chapterId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ["page-words", projectId, chapterId],
    queryFn: () => api<{ boxes: Record<string, [number, number, number, number, number]> }>(
      `/api/modules/proofing/projects/${projectId}/chapters/${chapterId}/page-words`),
    staleTime: 10 * 60_000,
    retry: false,
    enabled: enabled && !!projectId && !!chapterId,
  });
}

export const pagePicture = (projectId: string, page: number, width: number, fp: string) =>
  `/api/modules/proofing/projects/${projectId}/manuscript-pages/${page}.webp?w=${width}&v=${fp}`;
